module.exports = __webpack_public_path__ + "static/media/parallax-form-5.d2049c56.svg";